import React from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'

import HomeLarge from '../../components/HomeLarge';
import HomeMini from '../../components/HomeMini';

import CustomHeader from '../../components/Header'
import axiosConfig from '../../config/axiosConfig'


function Iframe(props) {

    return (
        <div>
            <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
        </div>
    )
}

class SuspiciousDashboardSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
    
            suspiciousdata: {},

            //reportBaseURL: 'http://localhost:40383/Charts?',
            reportBaseURL: 'https://shelltelematics.pk/TELEMATICSREPORTINGSERVICE/Charts?',
            reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
            reportViewType: '/SSSAS_TabularReports/',
            VRNMappingMasterId: '',
        };
        this.getSuspiciousData = this.getSuspiciousData.bind(this);
    }

    getSuspiciousData() {
        axiosConfig.post('Portal/GetDashBoardSuspiciousTransAnalytics', {
            "UserAccountBranchID": localStorage.getItem('selectedBranch'),
            "SearchTypeId": 1,
            "CardMappingMasterId": 0,
            "VRNGroupMasterId": 0,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
        })
            .then((res) => {
                this.setState({ suspiciousdata: res.data.suspiciousTranAnalytics[0] })
            })
            .catch(console.error)
            .finally(() => {

            });
    }

    componentDidMount() {
        this.getSuspiciousData();
    }

    render() {

        return (

            <div>
                <CustomHeader />

                <Container>
                    {/* 
                    <Card>
                        <Card.Body> */}
                    <Row>
                        <Card style={{ width: '100%', height: '50px' }}>
                            <Card.Body>
                                <a href="./MyReports" style={{ color: 'blue' }}>
                                    <p>For more details on your fleet’s performance, click here to visit My Reports</p>
                                </a>
                            </Card.Body>
                        </Card>

                    </Row>

                    <Row>
                        <Col>
                            <CardDeck>
                                <HomeLarge Title="Suspicious Transactions" Icon="fa fa-credit-card font-medium-5" />
                                <HomeMini status={this.state.suspiciousdata.suspiciousDifference} quantityPrice={this.state.suspiciousdata.totalSuspiciousTransactions} Icon="fa fa-exclamation-triangle text-info font-medium-5" percentage="-1" description="Total Suspicious Transactions" cssName="avatar bg-rgba-info p-50 m-0 mb-1" />
                                <HomeMini status={this.state.suspiciousdata.lowVehicleMileageDifference} quantityPrice={this.state.suspiciousdata.lowVehicleMileage} Icon="fa fa-map text-warning font-medium-5" percentage="-1" description="Low Vehicle Shell Card Mileage Transactions" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                                <HomeMini status={this.state.suspiciousdata.excessiveDailyFuelingDifference} quantityPrice={this.state.suspiciousdata.excessiveDailyFuelingTransactions} Icon="fa fa-database text-danger font-medium-5" percentage="-1" description="Excessive Daily Fueling Transactions" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                                <HomeMini status={this.state.suspiciousdata.locationMismatchTransactionsDifference} quantityPrice={this.state.suspiciousdata.locationMismatchTransactions} Icon="fa fa-map text-primary font-medium-5" percentage="-1" description="Location Mismatch Transactions" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                                <HomeMini status={this.state.suspiciousdata.deviatedRouteTransactionsDifference} quantityPrice={this.state.suspiciousdata.deviatedRouteTransactions} Icon="fa fa-tint text-success font-medium-5" percentage="-1" description="Deviated Route Transactions" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                            </CardDeck>
                        </Col>
                    </Row>

                </Container>
            </div >
        );
    }
}

export default SuspiciousDashboardSummary;